<template>
    <td class="px-4 py-3 whitespace-nowrap text-sm bg-white text-gray-800">
        <slot />
    </td>
</template>
